export { default as translations } from './translations.json';

/**
 * Get price change percentage between two entries.
 * @param {number} oldCents
 * @param {number} newCents
 * @returns {number} — positive = increase, negative = decrease
 */
export const getPriceChangePct = (oldCents, newCents) => {
  if (!oldCents) return 0;
  return Math.round(((newCents - oldCents) / oldCents) * 100);
};

/**
 * Get lowest price from history.
 * @param {Object[]} history
 * @returns {number|null}
 */
export const getLowestPrice = (history) => {
  if (!Array.isArray(history) || history.length === 0) return null;
  return Math.min(...history.map(h => h.priceCents));
};

/**
 * Get most recent price change.
 * @param {Object[]} history
 * @returns {{ change: number, from: number, to: number } | null}
 */
export const getLatestChange = (history) => {
  if (!Array.isArray(history) || history.length < 2) return null;
  const last = history[history.length - 1];
  const prev = history[history.length - 2];
  return { change: getPriceChangePct(prev.priceCents, last.priceCents), from: prev.priceCents, to: last.priceCents };
};
